module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';

	fox.registerWidget('Member_Unsubscribe', {
		configure: function() {
			this.hash = fox.Navigator.get(1);
			this.notificationAlias = fox.Navigator.get(2);

			this.registerOptions('', {
				widgets: {
					form: {
						widget: 'Form',
						autoApply: true,
						formElements: {
							mode: {
								element: '[name="mode"]'
							}
						},
						methods: {
							get: 'clientNotification.getSubscriptionStatus',
							send: 'clientNotification.unsubscribe',
							getParams: {
								hash: this.hash,
								alias: this.notificationAlias
							}
						},
						submit: {
							event: 'click',
							target: '#form-submit'
						},
						hooks: {
							onStopPrepareValues: fox.bind(this.prepareUnsubscribeData, this)
						}
					}
				},
				handleDom: {
					selectChanged: {
						event: 'change',
						target: '.amc-promo-select>select',
						callback: 'selectChanged'
					}
				},
				handleWom: {
					formSendSuccess: {
						widget: '#form #formDataSaveApi',
						event: 'success',
						callback: 'showSuccessMessage'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		prepareUnsubscribeData: function() {
			this.rwom1('#form')._preparedValues.hash = this.hash;
			this.rwom1('#form')._preparedValues.alias = this.notificationAlias;
		},

		selectChanged: function (el) {
			var $el = $(el);
			$el.parent().find('.placeholder').text($el.find('option:selected').text());
		},

		showSuccessMessage: function() {
			$('.notice-container.success').show();
		}
	});
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/promo/unsubscribe.js
// module id = 472
// module chunks = 2